import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import './index.css';

const DisableTryItOutPlugin = function() {
  return {
    statePlugins: {
      spec: {
        wrapSelectors: {
          allowTryItOutFor: () => () => false
        }
      }
    }
  }
}

const App = () => <SwaggerUI url="https://connectreport.s3.us-east-2.amazonaws.com/enterprise-api.json" plugins={[DisableTryItOutPlugin]} docExpansion="list"/>
export default App
